var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBackGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVG",
    clipPath: "url(#clip0_3015_28264)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Backward arrow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 10",
    d: "M5.5 11L6.5 10L2.714 6.214L11 6.214V4.786L2.714 4.786L6.5 1L5.5 0L0 5.5L5.5 11Z",
    fill: "#808080"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3015_28264"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white",
    transform: "matrix(-1 0 0 -1 11 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBackGrey);
export default __webpack_public_path__ + "static/media/arrow-back-grey.d99f667bd0b9cfbd7a04e5bf72682235.svg";
export { ForwardRef as ReactComponent };